import { forEach } from "jszip";

export const migrateTabUserSources = (sources : any, tabs : any) => {
  let migratedSources = sources;
  migratedSources = migrateVersion1(sources, tabs);
  migratedSources = migrateVersion2(migratedSources, tabs);  
  return migratedSources;
}

const migrateVersion1 = (sources, tabs) => {
  let migratedSources = sources;
  if (sources.length > 0) {
    if (sources[0].index === undefined) { //we have to migrate data to new structure       
       migratedSources = sources.map((source, index) => {
        const migrated = { ...tabs[0],
          code : source,
          index
        }
        return migrated;
      })            
    }
  }
  if (migratedSources.length !== tabs.length) {
    tabs.forEach((element, index) => {
      const nextIndex = migratedSources.reduce((a, b) => Math.max(a.index, b.index), -Infinity) + 1;
      const migratedSourceTab = migratedSources.find((srcElm) => srcElm.name == element.name);
      if (migratedSourceTab === undefined) {
        const newSourceTab = {
          ...element,
          index : nextIndex
        }
        migratedSources.push(newSourceTab);
      }
    });
  }
  return migratedSources;
}

const migrateVersion2 = (sources, tabs) => {
  let needsToMigrate = false;
  sources.forEach((source) => {
    const tab = tabs.find((tab) => tab.name === source.name);
    const oldSourcesFound = (tab.code === source.code || source.index === null);
    if (oldSourcesFound && needsToMigrate === false) {
      needsToMigrate = true;
    }
  })
  if (needsToMigrate === false) {
    return sources;
  }
  console.log('needs to migrate!')
  let migratedSources = sources.map((source, index) => {
    
    let migrated = { ...source };
    const tab = tabs.find((tab) => tab.name === source.name);
    console.log('sources contain file name?', source.code, tab.code);
    if (source.code === tab.code) {      
      migrated.code = tab.projectSource      
    }
    if (source.index === null) { 
      migrated.index = getNextIndex(sources)      
    }
    console.log('migrated source', migrated);
    return migrated;
  })
  return migratedSources;
}

const getNextIndex = (array) => {
  let nextIndex = 0;
  array.forEach((element) => {
    if (element.index !== null && element.index > nextIndex) {
      nextIndex = element.index;
    }
  })
  return nextIndex + 1;
}